import React, { useState, useEffect } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import axios from 'axios';
import '../../../assets/css/mainstyle.css';
import api from '../../../service/caller'; // Axios instance configurée
import { getUserIdFromToken } from '../../../utils/authUtils';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';


const AddPatientModal = ({ visible, onClose, onPatientAdded }) => {
    const [hospitals, setHospitals] = useState([]);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [formData, setFormData] = useState({
        patientNPI: '',
        firstname: '',
        lastname: '',
        age: '',
        gender: '',
        phone: '',
        email: '',
        hospitalId: '',
        address: '',
        otherdetails: '',
    });

    const navigate = useNavigate();  // Utilisation de useNavigate

    // Gestionnaire de modification générique pour tous les champs
    const handleChange = (e) => {
        const { name, value } = e.target || e; // Si c'est un événement standard ou PhoneInput
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Gestion de la modification pour PhoneInput (car il ne passe pas un événement classique)
    const handlePhoneChange = (phone) => {
        setFormData((prevData) => ({
            ...prevData,
            phone,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/clinic/patients/register', formData);
            setMessage('Patient ajouté avec succès!');
            setMessageType('success');
            const patientId = response.data.patient._id;  // Accéder à l'ID à partir de `patient`

            if (patientId) {
                // Rediriger vers la carte du patient avec l'ID
                navigate(`/patientcard/${patientId}`);
            }

            setFormData({
                patientNPI: '',
                firstname: '',
                lastname: '',
                age: '',
                gender: '',
                phone: '',
                email: '',
                hospitalId: '',
                address: '',
                otherdetails: ''
            });
        } catch (error) {
            console.error('Erreur lors de l’ajout du patient:', error);
            setMessage('Une erreur est survenue lors de l’ajout du patient.');
            setMessageType('error');
        }
    };

    const userId = getUserIdFromToken(); // Récupérer l'ID de l'utilisateur à partir du token

    // Fonction pour récupérer la liste des hôpitaux pour l'administrateur
    useEffect(() => {
        const fetchHospitals = async () => {
            if (!userId) {
                setMessage('Utilisateur non authentifié.');
                return;
            }
            try {
                const token = localStorage.getItem('access_token');
                const response = await api.get(`/api/hospitals/admin/` + token, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                    }
                });
                setHospitals(response.data); // Sauvegarder les hôpitaux dans l'état
            } catch (error) {
                console.error('Erreur lors de la récupération des hôpitaux:', error);
                setMessage('Erreur lors de la récupération des hôpitaux.');
            }
        };
        if (userId) {
            fetchHospitals(); // Appeler la fonction pour récupérer les hôpitaux uniquement si l'utilisateur est authentifié
        }
    }, [userId]); // Dépendance sur userId pour recharger si nécessaire

    return (
        <CModal className='newregistermodal'
            alignment="center"
            scrollable
            size='lg'
            visible={visible}
            onClose={onClose}
            aria-labelledby="VerticallyCenteredScrollableExample2">
            <CModalHeader>
                <CModalTitle>Register new patient</CModalTitle>
            </CModalHeader>
            <CModalBody className='p-5'>
                {message && (
                    <div className={`alert ${messageType === 'success' ? 'alert-success' : 'alert-danger'}`}>
                        {message}
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="patientNPI">NPI</label>
                        <input
                            type="Number"
                            name="patientNPI"
                            id="patientNPI"
                            value={formData.patientNPI}
                            onChange={handleChange}
                            placeholder="0598677474333"
                            required
                        />
                    </div>
                    <div className="form-row row">
                        <div className="form-group col-md-6">
                            <label htmlFor="firstname">Firstname</label>
                            <input
                                type="text"
                                name="firstname"
                                id="firstname"
                                value={formData.firstname}
                                onChange={handleChange}
                                placeholder="Casos"
                                required
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="lastname">Lastname</label>
                            <input
                                type="text"
                                name="lastname"
                                id="lastname"
                                value={formData.lastname}
                                onChange={handleChange}
                                placeholder="Billal"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-row row">
                        <div className="form-group col-md-4">
                            <label htmlFor="gender">Gender</label>
                            <select name="gender" id="gender" value={formData.gender} onChange={handleChange} required>
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <div className="form-group col-md-4">
                            <label htmlFor="age">Date of birth</label>
                            <input
                                max={new Date().toISOString().split("T")[0]}
                                type="date"
                                name="age"
                                id="age"
                                value={formData.age} onChange={handleChange} required
                                placeholder="20-12-2000"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="hospitalId">Hospital</label>
                            <select name="hospitalId" id="hospitalId" value={formData.hospitalId} onChange={handleChange} required>
                                <option value="">Select Hospital</option>
                                {hospitals.map((hospital) => (
                                    <option key={hospital._id} value={hospital._id}>
                                        {hospital.hospital_name} {/* Assurez-vous que votre modèle contient un champ 'name' */}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-row row telside">
                        <div className="form-group col-md-6">
                            <PhoneInput
                                country={'bj'}
                                value={formData.phone} // Liaison avec l'état formData.phone
                                onChange={handlePhoneChange} // Mise à jour de l'état lors de la modification
                                placeholder="Téléphone"
                                name="phone"
                                inputClass="w-100"
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                name="email"
                                onChange={handleChange} value={formData.email}
                                id="email"
                                placeholder="exemple@gmail.com"
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="address">Address</label>
                        <input
                            name="address"
                            id="address" value={formData.address}
                            onChange={handleChange}
                            placeholder="Your address here"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="otherdetails">Details</label>
                        <input
                            name="otherdetails"
                            id="otherdetails" onChange={handleChange} value={formData.otherdetails}
                            placeholder="Your Details here"
                        />
                    </div>

                    <div className="savenewuser form-group d-flex justify-content-center">
                        <CButton type="submit">
                            Continue &nbsp; <BsArrowRight />
                        </CButton>
                    </div>
                </form>
            </CModalBody>
        </CModal>
    );
};

export default AddPatientModal;
